export var FileExtention;
(function (FileExtention) {
    FileExtention["png"] = "png";
    FileExtention["jpg"] = "jpg";
})(FileExtention || (FileExtention = {}));
export const IAPIHTTPDataSourceType = Symbol('IAPIHTTPDataSource');
